function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 1H11C11.5625 1 12 1.4375 12 2V4H8V2C8 1.4375 8.4375 1 9 1ZM3 3H6.5V4C6.5 4.84375 7.1875 5.5 8 5.5H12C12.8438 5.5 13.5 4.84375 13.5 4V3H17C18.0938 3 19 3.90625 19 5V15C19 16.0938 18.0938 17 17 17H3C1.90625 17 1 16.0938 1 15V5C1 3.90625 1.90625 3 3 3ZM6.5 14.5C6.5 14.7812 6.71875 15 7 15H13C13.2812 15 13.5 14.7812 13.5 14.5C13.5 13.125 12.375 12 11 12H9C7.625 12 6.5 13.125 6.5 14.5ZM10 10.75C10.9688 10.75 11.75 9.96875 11.75 9C11.75 8.03125 10.9688 7.25 10 7.25C9.03125 7.25 8.25 8.03125 8.25 9C8.25 9.96875 9.03125 10.75 10 10.75Z",
  fill: "white"
});

function SvgSubmittedData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedData);
export default __webpack_public_path__ + "static/media/submitted-data.6114b5fa.svg";
export { ForwardRef as ReactComponent };